var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box box__content--padded" }, [
    _c("div", { staticClass: "box__header" }, [
      _c(
        "button",
        {
          staticClass: "c-btn float-right",
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_c("span", { staticClass: "icon-delete-ccs icon-ccs" })]
      ),
      _vm._v(" "),
      _c("h3", [_vm._v(_vm._s(_vm.entry.short_notice))])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box__content" },
      [
        _vm.entry.tag == "load2_servers" || _vm.entry.tag == "load10_server"
          ? [
              _c("load-status-modal", {
                attrs: { "server-list": _vm.entry.server_list }
              })
            ]
          : _vm.entry.hasOwnProperty("server_list") &&
            _vm.entry.server_list.length > 0
          ? [
              _c("server-list-modal", {
                attrs: { "server-list": _vm.entry.server_list }
              })
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }